'use client';

import { isEmpty } from '@cat-ecom/common/utils/commonUtils';
import { removeCookie } from '@cat-ecom/common/utils/cookieUtils';
import { removeSessionStorage } from '@cat-ecom/common/utils/storageUtils';
import { useInAppSignOut } from '@cat-ecom/pcc-components';
import { useEsiteCtx } from 'services/esite/context';
import {
  PARTS_SEARCH,
  PARTS_MANUAL,
  MANUAL_APPROVAL_MESSAGE,
  EQUIPMENT_VALUE,
  REQUEST_BY_DATE,
  CONSENT,
  LOGON_USER_COOKIE,
  RCLIST,
} from 'constants/storageConstants';


export const useLogout = () => {
  const { storeId } = useEsiteCtx();
  const { removeInAppCookie } = useInAppSignOut();
  const removeCookies = () => {
    const logonUserIdCookie = `${LOGON_USER_COOKIE}${storeId}`;
    const removeCustomCookies = () => {
      const rclist = document.getElementById(RCLIST) as HTMLInputElement;
      const rclistArray = rclist?.value?.split(',');
      if (!isEmpty(rclistArray)) {
        rclistArray.forEach((rclistitem) => removeCookie(rclistitem));
      }
    };
    removeCookie(logonUserIdCookie);
    removeCustomCookies();
    removeInAppCookie();
  };

  const removeStorage = () => {
    removeSessionStorage(PARTS_SEARCH);
    removeSessionStorage(PARTS_MANUAL);
    removeSessionStorage(MANUAL_APPROVAL_MESSAGE);
    removeSessionStorage(EQUIPMENT_VALUE);
    removeSessionStorage(REQUEST_BY_DATE);
    removeSessionStorage(CONSENT);
  };

  const logout = () => {
    removeCookies();
    removeStorage();
  };

  return { logout };
};
